// MIME wildcard returned by the config API for "accept all".
export const FILE_ACCEPT_ALL_MIME = '*/*';

// @cw-ui FileUpload validates by file extension (e.g. ".pdf"), not MIME wildcards.
export const FILE_EXTENSION_PDF = '.pdf';
export const FILE_EXTENSION_DOC = '.doc';
export const FILE_EXTENSION_DOCX = '.docx';
export const FILE_EXTENSION_XLS = '.xls';
export const FILE_EXTENSION_XLSX = '.xlsx';
export const FILE_EXTENSION_PPT = '.ppt';
export const FILE_EXTENSION_PPTX = '.pptx';
export const FILE_EXTENSION_TXT = '.txt';
export const FILE_EXTENSION_RTF = '.rtf';
export const FILE_EXTENSION_CSV = '.csv';

export const FILE_EXTENSION_PNG = '.png';
export const FILE_EXTENSION_JPG = '.jpg';
export const FILE_EXTENSION_JPEG = '.jpeg';
export const FILE_EXTENSION_GIF = '.gif';
export const FILE_EXTENSION_BMP = '.bmp';
export const FILE_EXTENSION_WEBP = '.webp';
export const FILE_EXTENSION_SVG = '.svg';

export const FILE_EXTENSION_ZIP = '.zip';
export const FILE_EXTENSION_RAR = '.rar';
export const FILE_EXTENSION_7Z = '.7z';
export const FILE_EXTENSION_TAR = '.tar';
export const FILE_EXTENSION_GZ = '.gz';

export const FILE_EXTENSION_MP4 = '.mp4';
export const FILE_EXTENSION_MOV = '.mov';
export const FILE_EXTENSION_AVI = '.avi';
export const FILE_EXTENSION_WMV = '.wmv';
export const FILE_EXTENSION_MP3 = '.mp3';
export const FILE_EXTENSION_WAV = '.wav';

export const FILE_EXTENSION_LOG = '.log';
export const FILE_EXTENSION_XML = '.xml';
export const FILE_EXTENSION_JSON = '.json';
export const FILE_EXTENSION_HTML = '.html';
export const FILE_EXTENSION_HTM = '.htm';

export const COMMON_FILE_EXTENSIONS = [
  FILE_EXTENSION_PDF,
  FILE_EXTENSION_DOC,
  FILE_EXTENSION_DOCX,
  FILE_EXTENSION_XLS,
  FILE_EXTENSION_XLSX,
  FILE_EXTENSION_PPT,
  FILE_EXTENSION_PPTX,
  FILE_EXTENSION_TXT,
  FILE_EXTENSION_RTF,
  FILE_EXTENSION_CSV,
  FILE_EXTENSION_PNG,
  FILE_EXTENSION_JPG,
  FILE_EXTENSION_JPEG,
  FILE_EXTENSION_GIF,
  FILE_EXTENSION_BMP,
  FILE_EXTENSION_WEBP,
  FILE_EXTENSION_SVG,
  FILE_EXTENSION_ZIP,
  FILE_EXTENSION_RAR,
  FILE_EXTENSION_7Z,
  FILE_EXTENSION_TAR,
  FILE_EXTENSION_GZ,
  FILE_EXTENSION_MP4,
  FILE_EXTENSION_MOV,
  FILE_EXTENSION_AVI,
  FILE_EXTENSION_WMV,
  FILE_EXTENSION_MP3,
  FILE_EXTENSION_WAV,
  FILE_EXTENSION_LOG,
  FILE_EXTENSION_XML,
  FILE_EXTENSION_JSON,
  FILE_EXTENSION_HTML,
  FILE_EXTENSION_HTM
];
